<template>
  <div>
    <!--
    <el-tabs type="border-card" >
      <el-tab-pane v-for="verification, index in educationVerifications" :key="'edu' + index">
        <span slot="label"><i class="fa qc2-edu" style="display: inline"/>&nbsp;&nbsp;Education # {{index}}</span>
        <transition-group name="fade" mode="out-in">
          <div key="SEARCH" v-if="!verification.institute">
            <institute-select @select="verification.institute = $event" />
          </div>
          <div key="SELECTED" v-else>
            <verification :verification="verification" :permissions="252" :multiScope="'edu' + index" />
          </div>                
        </transition-group>
      </el-tab-pane>
      <el-tab-pane v-for="verification, index in employmentVerifications" :key="'emp' + index">
        <span slot="label"><i class="fa fa-briefcase" style="display: inline"/>&nbsp;&nbsp;Employment # {{index}}</span>
        <verification :verification="verification" :permissions="252" :multiScope="'emp' + index" />
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="fa fa-plus" style="display: inline"/>&nbsp;&nbsp;Add another</span>
      </el-tab-pane>
    </el-tabs>
    -->
    <div v-if="$store.state.applicationInProgres && !(allowedCount() == 1 && allowed('idc'))" data-notify="container" class="col-md-12 alert alert-warning alert-with-icon" style="max-width: 98%; float: none; margin: auto; margin-bottom: 10px;">
      <span data-notify="icon" class="fa fa-exclamation"></span>
      <span data-notify="message" style="font-size: 120%">Please be sure to add <b>ALL</b> verifications you would like included in your application, along with the requested documentation, as the application is <b>closed</b> after submission.</span>
    </div>
    <div v-if="allowed('edu') && educationVerifications.length > 0" class="col-lg-12">
      <div v-loading="loadingInstitutes" element-loading-spinner="qc-spinner" class="card">
        <div class="card-header">
          <h4 class="card-title">
            <div class="document-card-title">
              <i class="fa-3x qc2-edu" style="display: inline"/>
              Education Verification
            </div>
          </h4>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <div v-if="educationVerifications.length == 1" class="un-collapse-item">
              <div key="SEARCH" v-if="!educationVerifications[0].institute">
                <institute-select :application="application" @select="educationVerifications[0].institute = $event" :hidePrice="!pays" v-validate="'required'" :data-vv-scope="'fieldsedu0'"/>
              </div>
              <div key="SELECTED" v-else>
                <verification :verification="educationVerifications[0]" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'edu0'" @deleteInstitute="educationVerifications[0].institute = null" :additionalDocsAllowed="ada(educationVerifications[0])" />
              </div>          
            </div>
            <qc-collapse v-else accordion :value="eduValue">
              <qc-collapse-item v-for="verification, index in educationVerifications" :inerror="errors.has('institute', 'fieldsedu' + index + '') || errors.any('fieldsedu' + index + '')" :name="'edu' + index" :key="'edu' + index">
                <div class="nowrap" slot="title" style="width: 100%">
                  {{$service.educationName(verification, index)}}
                </div>
                <transition-group  name="fade" mode="out-in" v-on:leave="$scrollTo('#contentTop')">
                  <div key="SEARCH" v-if="!verification.institute">
                    <institute-select :application="application" @select="verification.institute = $event" :hidePrice="!pays" v-validate="'required'" :data-vv-scope="'fieldsedu'+index"/>
                    <button @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>
                  <div key="SELECTED" v-else>
                    <verification :verification="verification" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'edu' + index" @deleteInstitute="verification.institute = null" :additionalDocsAllowed="ada(verification)" />
                    <button v-if="canRemove" @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>                
                </transition-group>
              </qc-collapse-item>
            </qc-collapse>
            <br/>
            <button v-if="canAdd" @click.prevent="addAnother('education')" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add {{educationVerifications.length > 0 ? 'another Education Verification' : 'one'}}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="allowed('hsc') && highschoolVerifications.length > 0" class="col-lg-12">
      <div v-loading="loadingHSInstitutes" element-loading-spinner="qc-spinner" class="card">
        <div class="card-header">
          <h4 class="card-title">
            <div class="document-card-title">
              <i class="fa-3x qc2-bul" style="display: inline"/>
              High School Verification
            </div>
          </h4>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <div v-if="highschoolVerifications.length == 1" class="un-collapse-item">
              <div key="HSSEARCH" v-if="!highschoolVerifications[0].institute">
                <country-institute-select :verification="highschoolVerifications[0]" :application="application" @select="highschoolVerifications[0].institute = $event" v-validate="'required'" :data-vv-scope="'fieldsedu0'"/>
              </div>
              <div key="HSSELECTED" v-else>
                <verification :verification="highschoolVerifications[0]" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'edu0'" @deleteInstitute="highschoolVerifications[0].institute = null" :additionalDocsAllowed="ada(highschoolVerifications[0])" />
              </div>          
            </div>
            <qc-collapse v-else accordion :value="hscValue">
              <qc-collapse-item v-for="verification, index in highschoolVerifications" :inerror="errors.has('institute', 'fieldshsc' + index + '') || errors.any('fieldshsc' + index + '')" :name="'hsc' + index" :key="'hsc' + index">
                <div class="nowrap" slot="title" style="width: 100%">
                  {{$service.highschoolName(verification, index)}}
                </div>
                <transition-group  name="fade" mode="out-in" v-on:leave="$scrollTo('#contentTop')">
                  <div key="HSSEARCH" v-if="!verification.institute">
                    <country-institute-select :verification="verification" :application="application" @select="verification.institute = $event" v-validate="'required'" :data-vv-scope="'fieldsedu'+index"/>
                    <button @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>
                  <div key="HSSELECTED" v-else>
                    <verification :verification="verification" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'hsc' + index" @deleteInstitute="verification.institute = null" :additionalDocsAllowed="ada(verification)" />
                    <button v-if="canRemove" @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>                
                </transition-group>
              </qc-collapse-item>
            </qc-collapse>
            <br/>
            <button v-if="canAdd" @click.prevent="addAnother('highschool')" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add {{highschoolVerifications.length > 0 ? 'another High School Verification' : 'one'}}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="allowed('emp') && employmentVerifications.length > 0" class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            <div class="document-card-title">
              <i class="fa-3x qc2-emp" style="display: inline"/>
              Employment History Verification
            </div>
          </h4>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <div v-if="employmentVerifications.length == 1" class="un-collapse-item">
              <div key="EMPSEARCH" v-if="!employmentVerifications[0].institute">
                <country-institute-select :verification="employmentVerifications[0]":application="application" @select="employmentVerifications[0].institute = $event" v-validate="'required'" :data-vv-scope="'fieldsemp0'"/>
              </div>
              <div key="EMPSELECTED" v-else>
                <verification :verification="employmentVerifications[0]" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'emp0'" />
              </div>
            </div>
            <qc-collapse v-else accordion :value="empValue">
              <qc-collapse-item v-for="verification, index in employmentVerifications" :inerror="errors.any('fieldsemp' + index + '')" :name="'emp' + index" :key="'emp' + index">
                <div class="nowrap" slot="title" style="width: 100%">
                  {{$service.employmentName(verification, index)}}
                </div>
                <transition-group  name="fade" mode="out-in" v-on:leave="$scrollTo('#contentTop')">
                  <div key="EMPSEARCH" v-if="!verification.institute">
                    <country-institute-select :verification="verification" :application="application" @select="verification.institute = $event" v-validate="'required'" :data-vv-scope="'fieldsemp'+index"/>
                    <button @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>
                  <div key="EMPSELECTED" v-else>
                    <verification :verification="verification" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'emp' + index" />
                    <button v-if="canRemove" @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>                
                </transition-group>
              </qc-collapse-item>
            </qc-collapse>
            <br/>
            <button v-if="canAdd" @click.prevent="addAnother('employment')" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add {{employmentVerifications.length > 0 ? 'another Employment Verification' : 'one'}}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="allowed('pli') && proflicVerifications.length > 0" class="col-lg-12">
      <div v-loading="loadingInstitutes" element-loading-spinner="qc-spinner" class="card">
        <div class="card-header">
          <h4 class="card-title">
            <div class="document-card-title">
              <i class="fa-3x qc2-pli" style="display: inline"/>
              Professional License Verification
            </div>
          </h4>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <div v-if="proflicVerifications.length == 1" class="un-collapse-item">
              <div key="SEARCH" v-if="!proflicVerifications[0].institute">
                <institute-select :application="application" @select="proflicVerifications[0].institute = $event" :hidePrice="!pays" v-validate="'required'" :data-vv-scope="'fieldspli0'"/>
              </div>
              <div key="SELECTED" v-else>
                <verification :verification="proflicVerifications[0]" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'pli0'" @deleteInstitute="proflicVerifications[0].institute = null" :additionalDocsAllowed="ada(proflicVerifications[0])" />
              </div>          
            </div>
            <qc-collapse v-else accordion :value="pliValue">
              <qc-collapse-item v-for="verification, index in proflicVerifications" :inerror="errors.has('institute', 'fieldspli' + index + '') || errors.any('fieldspli' + index + '')" :name="'pli' + index" :key="'pli' + index">
                <div class="nowrap" slot="title" style="width: 100%">
                  {{$service.proflicName(verification, index)}}
                </div>
                <transition-group  name="fade" mode="out-in" v-on:leave="$scrollTo('#contentTop')">
                  <div key="SEARCH" v-if="!verification.institute">
                    <institute-select :application="application" @select="verification.institute = $event" :hidePrice="!pays" v-validate="'required'" :data-vv-scope="'fieldspli'+index"/>
                    <button @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>
                  <div key="SELECTED" v-else>
                    <verification :verification="verification" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'pli' + index" @deleteInstitute="verification.institute = null" :additionalDocsAllowed="ada(verification)" />
                    <button v-if="canRemove" @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>                
                </transition-group>
              </qc-collapse-item>
            </qc-collapse>
            <br/>
            <button v-if="canAdd" @click.prevent="addAnother('proflic')" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add {{proflicVerifications.length > 0 ? 'another Professional License Verification' : 'one'}}</button>
          </div>
        </div>
      </div>
    </div>


    <div v-if="allowed('pce') && profcertVerifications.length > 0" class="col-lg-12">
      <div v-loading="loadingInstitutes" element-loading-spinner="qc-spinner" class="card">
        <div class="card-header">
          <h4 class="card-title">
            <div class="document-card-title">
              <i class="fa-3x qc2-pce" style="display: inline"/>
              Professional Certificate Verification
            </div>
          </h4>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <div v-if="profcertVerifications.length == 1" class="un-collapse-item">
              <div key="SEARCH" v-if="!profcertVerifications[0].institute">
                <institute-select :application="application" @select="profcertVerifications[0].institute = $event" :hidePrice="!pays" v-validate="'required'" :data-vv-scope="'fieldspce0'"/>
              </div>
              <div key="SELECTED" v-else>
                <verification :verification="profcertVerifications[0]" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'pce0'" @deleteInstitute="profcertVerifications[0].institute = null" :additionalDocsAllowed="ada(profcertVerifications[0])" />
              </div>          
            </div>
            <qc-collapse v-else accordion :value="pceValue">
              <qc-collapse-item v-for="verification, index in profcertVerifications" :inerror="errors.has('institute', 'fieldspce' + index + '') || errors.any('fieldspce' + index + '')" :name="'pce' + index" :key="'pce' + index">
                <div class="nowrap" slot="title" style="width: 100%">
                  {{$service.profcertName(verification, index)}}
                </div>
                <transition-group  name="fade" mode="out-in" v-on:leave="$scrollTo('#contentTop')">
                  <div key="SEARCH" v-if="!verification.institute">
                    <institute-select :application="application" @select="verification.institute = $event" :hidePrice="!pays" v-validate="'required'" :data-vv-scope="'fieldspce'+index"/>
                    <button @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>
                  <div key="SELECTED" v-else>
                    <verification :verification="verification" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'pce' + index" @deleteInstitute="verification.institute = null" :additionalDocsAllowed="ada(verification)" />
                    <button v-if="canRemove" @click.prevent="deleteV(verification)" type="button" class="btn btn-sm"><i class="fa fa-trash"></i> Delete verification</button>
                  </div>                
                </transition-group>
              </qc-collapse-item>
            </qc-collapse>
            <br/>
            <button v-if="canAdd" @click.prevent="addAnother('profcert')" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add {{profcertVerifications.length > 0 ? 'another Professional Certificate Verification' : 'one'}}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="allowed('idc') && idcheckVerifications.length > 0" class="col-lg-12">
      <div v-loading="loadingIDC" element-loading-spinner="qc-spinner" class="card">
        <div class="card-header">
          <h4 class="card-title">
            <div class="document-card-title">
              <i class="fa fa-3x fa-id-badge" style="display: inline"/>
              Identity Document Verification
            </div>
          </h4>
        </div>
        <div class="card-content row">
          <div class="col-lg-12">
            <div v-if="idcheckVerifications.length == 1" class="un-collapse-item">
              <verification :verification="idcheckVerifications[0]" :application="application" :permissions="canRemove ? 252 : 248" :multiScope="'idc0'" @deleteInstitute="" :additionalDocsAllowed=0 />
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-lg-12">
      <div class="card">
        <div class="card-content row">
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-1 control-label">Terms & Consent</label>
              <div class="col-md-10">
                <p class="form-control-static"><p-switch v-model="consentTicked" type="info" on-text="Yes" off-text="No"></p-switch></p>
                <span class="help-block">
                  <ul>
                    <li v-if="$store.state.isIndividual">I am the individual named above and have provided copies of written consent where requested.</li>
                    <li v-else>I hold the written consent of the individuals named above and have provided copies of these consents where requested.</li>
                    <li>I agree to the <a href="https://www.qualificationcheck.com/terms-and-conditions/" target="_blank">terms and conditions</a> and <a href="https://www.qualificationcheck.com/privacy-notice/" target="_blank">privacy notice</a> for use of this service.</li>
                    <li>I acknowledge that the above details and my associated personal data may be passed to an institution, organisation, partner or agent outside the EEA.</li>
                  </ul>
                </span>
              </div>
            </div>
            <!-- <div v-if="this.application" class="form-group">
              <label class="col-md-1 control-label">Ready to complete</label>
              <div class="col-md-10">
                <p class="form-control-static"><p-switch v-model="consentTicked" type="info" on-text="Yes" off-text="No"></p-switch></p>
                <span class="help-block">I have added all the verifications required for the application to {{application.owner.name}}. I understand that by submitting these verifications it will close the application, with no further additions possible, and automatically share the final results with {{application.owner.name}} as they become available.</span>
                <button @click.prevent="$emit('newVerification')" type="button" class="btn btn-wd"><i class="fa fa-plus"></i> Add another verification</button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 card card-plain"> 
      <button v-if="paysNow" @click.prevent="lastChecks('saveAndCard')" v-bind:disabled="!allValid || !consentTicked" v-bind:class="{'btn-disabled': !allValid || !consentTicked}" type="button" class="btn btn-wd btn-fill btn-move-right pull-right">Next<span class="btn-label"><i class="ti-angle-right"></i></span></button>
      <button v-else @click.prevent="lastChecks('saveAndPay')" type="button" v-bind:disabled="!allValid || !consentTicked" v-bind:class="{'btn-disabled': !allValid || !consentTicked}" class="btn btn-wd btn-fill btn-move-right pull-right">Submit<span class="btn-label"><i class="ti-angle-right"></i></span></button>
    </div>
  </div>
</template>

<script>
  import InstituteSelect from 'src/views/Verifications/components/InstituteSelect'
  import CountryInstituteSelect from 'src/views/Verifications/components/CountryInstituteSelect'
  import Verification from 'src/views/Verifications/components/Verification'
  import QCCollapse from 'src/components/QCCollapse'
  import QCCollapseItem from 'src/components/QCCollapseItem'
  import PSwitch from 'src/components/Switch.vue'
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'
  import IDoc from 'src/views/Verifications/components/IDoc'

  import { Loading } from 'element-ui';
  import LogRocket from 'logrocket';
  import moment from 'moment'

  export default {
    name: "multi-verification", 
    components: {
      InstituteSelect,
      CountryInstituteSelect,
      Verification,
      'idoc' : IDoc,
      'qc-collapse': QCCollapse,
      'qc-collapse-item': QCCollapseItem,
      PSwitch
    },
    inject: ['$validator'],
    props: {
      application: { type: Object, default: null},
      verifications: { type: Array, default() {
        return []
      }},
      loadingInstitutes: {type: Boolean, deafult: false}
    },
    data () {
      return {
        allValid: true,
        eduValue: null,
        empValue: null,
        pliValue: null,
        pceValue: null,
        hscValue: null,
        consentTicked: false,
        loadingHSInstitutes: false,
        loadingIDC: false
      }
    },
    mounted() {
      if(this.$route.query.nedu) {
        this.addAnother('education')
      }
      if(this.$route.query.nemp) {
        this.addAnother('employment')
      }
      if(this.$route.query.npli) {
        this.addAnother('proflic')
      }
      if(this.$route.query.npce) {
        this.addAnother('profcert')
      }
      if(this.$route.query.nidc) {
        this.addAnother('identity')
      }
      if(this.$route.query.nhsc) {
        this.addAnother('highschool')
      }
      this.eduValue = this.initCollapse('edu')
      this.empValue = this.initCollapse('emp')
      this.pliValue = this.initCollapse('pli')
      this.pceValue = this.initCollapse('pce')
      this.hscValue = this.initCollapse('hsc')
      if(this.idcheckVerifications.length > 0) {
        this.loadingIDC = true
        //this.allValid = false
        this.$service.buildInstitute("QC_ID_VER_TRUST_ID", null, this.application ? this.application.id : null)
          .then(response => {
            this.idcheckVerifications[0].institute = response
            this.loadingIDC = false
          })
          .catch(error => {
            console.log(error)
            this.loadingIDC = false
          })
      }
    },
    computed: {
      pays() {
        if(this.application && !this.application.applicantPays) {
          return false
        } else {
          return (this.$store.state.paymentType == 'CARD' || this.$store.state.paymentType == 'INVOICE')
        }
      },
      paysNow() {
        return this.pays && this.$store.state.paymentType == 'CARD'
      },
      canAdd() {
        return !(this.application && this.application.lockedInstitutes)
      },
      canRemove() {
        return !(this.application && this.application.lockedInstitutes)
      },
      educationVerifications() {
        var edus = []
        this.verifications.forEach((v, i) => {
          if(v.type == 'education') {
            v.superIndex = i
            edus.push(v)
            v.segmentIndex = edus.length - 1
          }
        });
        return edus
      },
      employmentVerifications() {
        var emps = []
        this.verifications.forEach((v, i) => {
          if(v.type == 'employment') {
            v.superIndex = i
            emps.push(v)
            v.segmentIndex = emps.length - 1
          }
        });
        return emps
      },
      proflicVerifications() {
        var plis = []
        this.verifications.forEach((v, i) => {
          if(v.type == 'proflic') {
            v.superIndex = i
            plis.push(v)
            v.segmentIndex = plis.length - 1
          }
        });
        return plis
      },
      profcertVerifications() {
        var pces = []
        this.verifications.forEach((v, i) => {
          if(v.type == 'profcert') {
            v.superIndex = i
            pces.push(v)
            v.segmentIndex = pces.length - 1
          }
        });
        return pces
      },
      idcheckVerifications() {
        var idcs = []
        this.verifications.forEach((v, i) => {
          if(v.type == 'idcheck') {
            v.superIndex = i
            idcs.push(v)
            v.segmentIndex = idcs.length - 1
          }
        });
        return idcs
      },
      highschoolVerifications() {
        var hscs = []
        this.verifications.forEach((v, i) => {
          if(v.type == 'highschool') {
            v.superIndex = i
            hscs.push(v)
            v.segmentIndex = hscs.length - 1
          }
        });
        return hscs
      }
    },
    methods: {
      allowed(type) {
        if(this.application != null && this.application.allowedTypes) {
          return JSON.parse(this.application.allowedTypes).map(type => type.key).includes(type)
        }
        return this.$store.getters.allowed(type)
      },
      allowedCount() {
        if(this.application != null && this.application.allowedTypes) {
          return JSON.parse(this.application.allowedTypes).length
        }
        return this.$store.getters.allowedTypes.length
      },
      // educationName(verification, index) {
      //   return this.instituteName(verification, index, 'Education')
      // },
      // employmentName(verification, index) {
      //   var name = null
      //   if(verification.institute) {
      //     for(var i = 0; i < verification.institute.fields.length; i++) {
      //       if(verification.institute.fields[i].key === 'employerName' && verification.institute.fields[i].value) {
      //         name = 'Employment Verification at ' + verification.institute.fields[i].value
      //       }
      //     }
      //   }
      //   if(name == null) {
      //     name = 'Employment Verification ' + (index + 1)
      //   } 
      //   verification.name = name
      //   return name
      // },
      // proflicName(verification, index) {
      //   return this.instituteName(verification, index, 'Professional License')
      // },
      // profcertName(verification, index) {
      //   return this.instituteName(verification, index, 'Professional Certificate')
      // },
      // highschoolName(verification, index) {
      //   return this.instituteName(verification, index, 'High School')
      // },
      // instituteName(verification, index, label) {
      //   var name = null
      //   if(verification.institute) {
      //     name = label + ' Verification at ' + (verification.institute.names && verification.institute.names.length > 0 ? verification.institute.names[0].name : verification.institute.name)
      //   } else {
      //     name = label + ' Verification ' + (index + 1)
      //   }
      //   verification.name = name
      //   return name
      // },
      initCollapse(name) {
        if(this.verifications.length == 1) {
          return name + '0'
        } else {
          return null
        }
      },
      deleteV(verification) {
        this.$modal.show(ModalOptions,
          {
            title: "Delete Verification",
            message: "Are you sure you want to delete " + verification.name + "?",
            closeText: "Cancel",
            actionText1: "Delete",
            actionIcon1: "fa fa-trash",
            action1: () => 
              {
                if(verification.superIndex >= 0) { 
                  this.verifications.splice(verification.superIndex, 1)
                }
                this.eduValue = "deleted-" + moment() // hack to collapse menu again
                this.empValue = "deleted-" + moment() // hack to collapse menu again
                this.pliValue = "deleted-" + moment() // hack to collapse menu again
                this.pceValue = "deleted-" + moment() // hack to collapse menu again
                this.$modal.close()
              }
            }
          )
      },
      addAnother(type) {
        var v = {
            firstname: null,
            middlename: null,
            lastname: null,
            dob: null,
            institute: null,
            customerReference: null,
            new: true
        }
        if(type == 'education') {
          v.type = 'education'
          this.verifications.push(v)
          setTimeout(() => {
            this.eduValue = "edu" + v.segmentIndex
          }, 50)
        }
        if(type == 'employment') {
          LogRocket.track('Emp');
          LogRocket.track('AddEmp');
          var loading = Loading.service({
            spinner: 'qc-spinner',
            text: 'Adding another verification'
          })
          this.$service.populateEmploymentVerification(v)
            .then(response => {
              this.verifications.push(response)
              setTimeout(() => {
                this.empValue = "emp" + v.segmentIndex
              }, 50)
              loading.close()
            })
            .catch(error => {
              loading.close()
              console.log(error)
              this.$snotify.error("Error adding a new employment verification. Please try again.", "Error", {
                timeout: 7500
              })
            })
        }        
        if(type == 'proflic') {
          v.type = 'proflic'
          this.verifications.push(v)
          setTimeout(() => {
            this.pliValue = "pli" + v.segmentIndex
          }, 50)
        }
        if(type == 'profcert') {
          v.type = 'profcert'
          this.verifications.push(v)
          setTimeout(() => {
            this.pceValue = "pce" + v.segmentIndex
          }, 50)
        }
        if(type == 'highschool') {
          v.type = 'highschool'
          v.subjects = [{name: null, mark: null}]
          this.verifications.push(v)
          setTimeout(() => {
            this.pceValue = "hsc" + v.segmentIndex
          }, 50)
        }
        if(type == 'identity') {
          v.type = 'idcheck'
          this.verifications.push(v)
          setTimeout(() => {
            this.idcValue = "idc" + v.segmentIndex
          }, 50)
        }
      },
      ada(verification) {
        if(verification) {
          return verification.institute ? (verification.institute.allowsPending ? verification.institute.maxAdditionalDocs : 0) : 5
        } else {
          return 5
        }
      },
      lastChecks(emitParam) {
        var _this = this
        if(this.verifications.some(v => {
          return v.institute == null
        })) {
          this.$snotify.error("At least one verification has no institute selected. Please select an institute by clicking the institute name in the table of search results.", "Error", {
            timeout: 7500
          })
          this.$store.commit('setSelectionWarning', true)
        }
        if(this.application != null && !(this.allowedCount() == 1 && this.allowed('idc'))) {
          this.$modal.show(ModalOptions,
          {
            doLoading: _this.application.owner.template != 17,
            title: "Submit & Complete Application?",
            message: "Have you added all the credential verifications required for your application to " + this.application.owner.name + "?",
            closeText: "No, Add another verification",
            actionText1: "Yes, Submit & complete application",
            closeAction: () => 
              {
                this.$modal.close()
                this.$emit('newVerification')
              },
            action1: () => 
              {
                this.$modal.close()
                if(_this.application.owner.template != 17) {
                  this.$emit(emitParam)
                } else {
                  this.showWESModal(emitParam)
                }
              }
            }
          )
        } else {
          this.$emit(emitParam)
        }
      },
      showWESModal(emitParam) {
        this.$modal.show(ModalOptions,
          {
            title: "Included all year transcripts?",
            message: "Have you included all transcripts from all years of study? Your WES application will remain on hold until all transcripts are verified.",
            closeText: "No, I'll add them now",
            actionText1: "Yes, I'm sure I've included all required documents",
            closeAction: () => 
              {
                this.$modal.close()
              },
            action1: () => 
              {
                this.$modal.close()
                this.$emit(emitParam)
              }
            }
          )
      }
    }
  }
</script>
<style scoped>
  .nowrap {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .un-collapse-item {
    overflow: auto;
    background-color: #F9F7F3;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 300;
    line-height: 1.6em;
    margin-top: 10px;
    padding: 7px 10px;
    border: 1px solid #e8e7e3;
  }
</style>